

const ServiceDetail = ({data}) => {
  return (
    <>
      <section className="serviceSection sectionPD">
        <div className="container">
          <div className="fisherman-content">
            <h3>{data?.title}</h3>
          </div>

          <div className="serviceDetail">
            <div className="header">
              <img
                src={data?.banner}
                alt={data?.title}
                className="img-fluid"
                title={data?.title}
              />
              <p>{data?.desc1}</p>
              <p>{data?.desc2}</p>
            </div>
            <div className="body">
              <strong>{data?.common}</strong>
              <h4>{data?.mainTitle}</h4>

              {data?.list.map((item, i) => {
                return (
                  <div className="item" key={i}>
                    <h6>{item.title}</h6>
                    <p>{item.desc}</p>
                    <ul>
                      {item.items.map((name, i) => {
                        return <li key={i}>{name}</li>;
                      })}
                    </ul>
                  </div>
                );
              })}
            </div>
            <div className="footer">
              <p>{data?.footer}</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServiceDetail;
